import { Mark } from '@tiptap/core'
import { ReactMarkViewRenderer } from '@tiptap/react'
import {
  INSUFFICIENT_INFORMATION_PLACEHOLDER,
  INSUFFICIENT_INFORMATION_REGEX,
} from '@artem-lex/compliance-documents'
import { InsufficientInformationMarkView } from './InsufficientInformationMarkView'

export {
  INSUFFICIENT_INFORMATION_PLACEHOLDER as INSUFFICIENT_INFORMATION_TOKEN,
  INSUFFICIENT_INFORMATION_REGEX,
}

export const INSUFFICIENT_INFORMATION_MARK = 'insufficientInformation'

export interface InsufficientInformationMatch {
  index: number
  length: number
  text: string
}

/**
 * Finds every insufficient-information token in `text`.
 */
export function findInsufficientInformationMatches(
  text: string
): InsufficientInformationMatch[] {
  const matches: InsufficientInformationMatch[] = []
  INSUFFICIENT_INFORMATION_REGEX.lastIndex = 0
  let nextMatch = INSUFFICIENT_INFORMATION_REGEX.exec(text)
  while (nextMatch !== null) {
    matches.push({
      index: nextMatch.index,
      length: nextMatch[0].length,
      text: nextMatch[0],
    })
    nextMatch = INSUFFICIENT_INFORMATION_REGEX.exec(text)
  }
  return matches
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    insufficientInformation: {
      setInsufficientInformation: () => ReturnType
      unsetInsufficientInformation: () => ReturnType
    }
  }
}

export const InsufficientInformationMark = Mark.create({
  name: INSUFFICIENT_INFORMATION_MARK,
  inclusive: false,

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  addMarkView() {
    return ReactMarkViewRenderer(InsufficientInformationMarkView)
  },

  addAttributes() {
    return {}
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-insufficient-information]',
        getAttrs: () => ({}),
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      {
        class: 'insufficient-information',
        'data-insufficient-information': '',
        ...this.options.HTMLAttributes,
        ...HTMLAttributes,
      },
      0,
    ]
  },

  renderMarkdown: () => INSUFFICIENT_INFORMATION_PLACEHOLDER,
})
